import { useSyncExternalStore } from "react";

/**
 * Raised while a dialog is detached into its own window (see `openPopout`). Pages
 * read it to disable only what would change the data the dialog is working from —
 * a new search, or anything that opens another dialog. Reading, scrolling, sorting
 * and paging stay available, since reading the list is the point of detaching.
 */

let locked = false;
const listeners = new Set<() => void>();

/**
 * Raised while a detached dialog is open, cleared when it docks or closes.
 *
 * A single boolean rather than a ref count: the lock makes the bulk action buttons
 * inert, so a second popout cannot be opened while one is live. Ref-count this if
 * that stops holding — a second caller's clear would otherwise release the first's.
 */
export function setPageLockedByPopout(value: boolean): void {
  if (locked === value) return;
  locked = value;
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

const getSnapshot = () => locked;

/** True while a detached dialog is open. */
export function usePageLockedByPopout(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
